// extracted by mini-css-extract-plugin
export default {"two_btn_popup":"TwoBtnPopUp_two_btn_popup__HCOr4","title":"TwoBtnPopUp_title__SXoiU","buttons":"TwoBtnPopUp_buttons__XsX09","confirm_btn":"TwoBtnPopUp_confirm_btn__bl4N1"};